import { HelpTopic } from 'data/entities/entities';
import { AppRepository } from '../app-repository';

export class HelpTopicPreferenceRepository extends AppRepository {
	updatePreference(helpTopicId: number, show: boolean): any {
		this.find(`updateHelpTopicPreference?helpItemId=${helpTopicId}&show=${show}`);
    }
	

}
